<template>
  <div :class="componentClass.root">
    <div :class="componentClass.element('content')">
      <div :class="componentClass.element('kw')">{{ kwFormatted }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useComponentClass } from '@thomasaull-shared/composables'
import { formatWithLocale } from '@/utilities/date'

export interface Props {
  date: Date
}

const props = defineProps<Props>()

const componentClass = useComponentClass({ props })

const kwFormatted = computed(() => {
  return 'KW ' + formatWithLocale(props.date, 'ww')
})
</script>

<style lang="scss">
.PmCalendarWeekPure {
  $block: &;

  @include cssVar.define($block, 'gradientWidth', 50px);

  pointer-events: none;
  user-select: none;
  z-index: 3;
  width: 100%;
  display: flex;

  &-content {
    position: sticky;
    top: 0;
    left: var(--sidebarLeftWidth, 0);
    padding-left: var(--space-gutters);
    padding-right: var(--space-gutters);
    height: 100%;
    flex: none;
  }

  &-kw {
    @include mixin.textLabel;

    position: relative;
    z-index: 1;
  }
}
</style>
